const state = {
  campaignSlug: 0,
  constantes: [],
  contactInfo: {
    address: '',
    zipCode: '',
    city: '',
    province: '',
    country: '',
    phone: '',
    mobile: ''
  },
  currentLang: '',
  donationInfo: {
    type: undefined,
    amount: 0
  },
  langues: [],
  infosPaysafe: undefined,
  params: {
    formParams: {
      campaign: {
        label: [],
        objective: 0,
        projects: [],
        totalDonations: 0,
        endDate: null,
      },
      civilites: [],
      langue: {},
      title: '',
      subtitle: '',
      logo: '',
      content: '',
      description: '',
      paymentTool: '',
      publishObjective: false,
      showSocialMediaNetworks: false,
      showFooter: false,
      defaultCountry: {},
      defaultProvince: {},
      adr1: '',
      adr2: '',
      adr3: '',
      phone: '',
      email: '',
      clientName: '',
      facebook: '',
      twitter: '',
      linkedin: '',
      website: '',
      shareFB: false,
      thanksMessage: '',
      currency: {},
      autoriserUneDedicace: false,
      typeDeChamp: "outlined",
      donateurDefinitDateDebut: false,
    },
    expired: false,
    suggestedAmounts: [],
    donationTypes: [],
    countries: [],
    provinces: [],
    typesDedicaces: [],
    typesCommunications: []
  },
  paramsMultilingue: [],
  personalInfo: {
    firstName: '',
    lastName: '',
    email: '',
    civility: null,
    isCompany: '',
    companyName: ''
  },
  jeVeuxFaireUneDedicace: false,
  dedicaceInfo: {
    nomDuDefunt: '',
    aviserLaFamille: null,
    nom: '',
    prenom: '',
    courriel: '',
    adresse: '',
    cp: '',
    ville: '',
    province: null,
    pays: null,
  },
  traductions: [],
  url: ''
};
export default state;